import { setI18nLocale } from "@/plugins/i18n";
import { useAccountStore } from "@/_store/account.module";

/**
 * Loads the messages of the language the first screen renders in; `main.ts` mounts the app once
 * this settles, so a non-English user never sees the English fallback first.
 *
 * Non-English messages are fetched on demand (see `setI18nLocale`). The account's display language
 * already follows the URL before the first navigation lands (a route's preferred locale — public
 * auth pages follow the browser language), so the first navigation is deliberately not awaited:
 * its guards make API calls (`/portal` checks MSP access), and the app shell must not stay blank,
 * or never appear when a request hangs, while they run. If a guard redirects to a route with
 * another preferred locale, the App watcher on `displayLanguage` switches to it.
 *
 * Never rejects: whatever fails, the app still mounts, in English.
 */
export async function loadInitialLocale(): Promise<void> {
  try {
    await setI18nLocale(useAccountStore().displayLanguage);
  } catch (error) {
    console.error("[i18n] Failed to load the initial locale", error);
  }
}
